module.exports = __webpack_public_path__ + "media/images/sk250-e7f9874c4808ff48c73fa272be59940d.svg";